import { useState } from "react";

import { Grid, Box, makeStyles } from "@material-ui/core";

import { comparisonChartData } from "../sample";
import { COLORS } from "../../../../../theme/colors";
import { ShaDowBox } from "../../../../../components/boxes";
import { profileGraphFooter, comparisonChartLines } from "../../../constants";
import { Progresses, LinearChartPart, NoDataCard } from "../../../../../components/parts";
import { ReactComponent as TenantImg } from "../../../../../assets/images/icons/tenant.svg";
import { useSelector } from "react-redux";
import { DEMO_ACCOUNT_EMAIL } from "../../../../../redux/auth";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  tenantImg: {
    fill: COLORS.white,
    "& path": {
      stroke: COLORS.white,
    },
    width: 11,
  },
  smallTenantImg: {
    fill: COLORS.white,
    "& path": {
      stroke: COLORS.white,
    },
    width: 7,
  },
}));

export const Traction = () => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);
  const showPlaceholder = user.email === DEMO_ACCOUNT_EMAIL;
  /* eslint-disable no-unused-vars */
  const [tenantOverallTraction, setTenantOverallTraction] = useState(showPlaceholder);
  const [overTime, setOverTime] = useState(showPlaceholder);
  const [rentalProfitability, setRentalProfitability] = useState(showPlaceholder);
  const [electricityConsumption, setElectricityConsumption] = useState(showPlaceholder);
  const [praasProfitability, setPraasProfitability] = useState(showPlaceholder);

  const tenantOverallTractionTitle = "Tenant Overall Traction";
  const overTimeTitle = "Total profits - over time";
  const rentalProfitabilityTitle = "Rental Profitability";
  const electricityConsumptionTitle = "Electricity Consumption";
  const praasProfitabilityTitle = "PRaaS Profitability";

  return (
    <Grid container spacing={3}>
      <Grid item xs={8}>
        <ShaDowBox fullHeight>
          {tenantOverallTraction ? (
            <Box className={classes.root}>
              <Progresses
                title={tenantOverallTractionTitle}
                insideStyle={{ backgroundColor: COLORS.purple }}
                insideIcon={<TenantImg className={classes.tenantImg} />}
                mainPointLeft={83}
                insideText="83%"
              />
            </Box>
          ) : (
            <NoDataCard title={tenantOverallTractionTitle} withShaDowBox={false} />
          )}
          {overTime ? (
            <LinearChartPart
              showProgress={true}
              titleStyle={{ marginBottom: 20, marginLeft: 32 }}
              title={overTimeTitle}
              chartData={comparisonChartData}
              chartLines={comparisonChartLines}
              graphFooterItems={profileGraphFooter}
            />
          ) : (
            <NoDataCard
              title={overTimeTitle}
              type="line"
              withShaDowBox={false}
              footerNames={["This Tenant", "Avg. building", "Avg. portfolio", "Avg. Industry"]}
            />
          )}
        </ShaDowBox>
      </Grid>
      <Grid item xs={4}>
        <ShaDowBox fullHeight>
          <Box style={{ padding: "40px 36px" }}>
            {rentalProfitability ? (
              <Progresses
                size="small"
                boxStyle={{
                  padding: 0,
                  backgroundColor: COLORS.white,
                }}
                title="Rental Profitability"
                insideIcon={<TenantImg className={classes.smallTenantImg} />}
                mainPointLeft={50}
                insideText="50%"
                points={[
                  { type: "building", left: 30 },
                  { type: "portfolio", left: 50 },
                  { type: "industry", left: 70 },
                ]}
              />
            ) : (
              <NoDataCard
                title={rentalProfitabilityTitle}
                withShaDowBox={false}
                boxStyle={{ padding: 0 }}
                gridStyle={{ height: 105 }}
                iconStyle={{ height: 75 }}
              />
            )}
            {electricityConsumption ? (
              <Progresses
                size="small"
                boxStyle={{
                  padding: "40px 0 0",
                  backgroundColor: COLORS.white,
                }}
                title="Electricity Consumption"
                insideIcon={<TenantImg className={classes.smallTenantImg} />}
                mainPointLeft={96}
                insideText="96%"
                points={[
                  { type: "building", left: 30 },
                  { type: "portfolio", left: 50 },
                  { type: "industry", left: 70 },
                ]}
              />
            ) : (
              <NoDataCard
                title={electricityConsumptionTitle}
                withShaDowBox={false}
                boxStyle={{ padding: "40px 0 0" }}
                gridStyle={{ height: 105 }}
                iconStyle={{ height: 75 }}
              />
            )}
            {praasProfitability ? (
              <Progresses
                size="small"
                boxStyle={{
                  padding: "40px 0 0",
                  backgroundColor: COLORS.white,
                }}
                title="PRaaS profitability"
                insideIcon={<TenantImg className={classes.smallTenantImg} />}
                mainPointLeft={83}
                insideText="83%"
                points={[
                  { type: "building", left: 30 },
                  { type: "portfolio", left: 50 },
                  { type: "industry", left: 70 },
                ]}
              />
            ) : (
              <NoDataCard
                title={praasProfitabilityTitle}
                withShaDowBox={false}
                boxStyle={{ padding: "40px 0 0" }}
                gridStyle={{ height: 105 }}
                iconStyle={{ height: 75 }}
              />
            )}
          </Box>
        </ShaDowBox>
      </Grid>
    </Grid>
  );
};
